import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "react-oidc-context";
import LoadingPage from "@/pages/LoadingPage";
import ErrorPage from "@/pages/ErrorPage";

interface Props {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<Props> = ({ children }) => {
  const auth = useAuth();

  useEffect(() => {
    const onSilentRenewError = () => auth.signinRedirect();
    const onTokenExpired = () => void auth.signinSilent().catch(() => auth.signinRedirect());

    auth.events.addSilentRenewError(onSilentRenewError);
    auth.events.addAccessTokenExpired(onTokenExpired);
    return () => {
      auth.events.removeSilentRenewError(onSilentRenewError);
      auth.events.removeAccessTokenExpired(onTokenExpired);
    };
  }, [auth]);

  if (auth.isLoading) return <LoadingPage />;
  if (auth.error) return <ErrorPage title="Authentication error" message={auth.error.message} />;
  if (!auth.isAuthenticated) return <Navigate to="/login" replace />;

  return <>{children}</>;
};

export default PrivateRoute;
